import { mapEnumToOptions } from '@abp/ng.core';

export enum CreatorType {
  Streamer = 0,
  ProGamer = 1,
  Vtuber = 2,
}

export const creatorTypeOptions = mapEnumToOptions(CreatorType);
